import React, { useEffect, useRef } from 'react';
import { COLORS, Input } from '@podiumhq/design-system';
import useMediaQuery from 'hooks/useMediaQuery';

const OtpInput = ({
  autoFocus,
  disabled,
  error,
  focus,
  index,
  isLast,
  onInputFocus,
  otpType,
  value = '',
  ...rest
}) => {
  const input = useRef(null);
  const componentMounted = useRef(false);
  const isMobile = useMediaQuery();

  useEffect(() => {
    if (autoFocus && focus) {
      input.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (componentMounted.current && focus) {
      input.current.focus();
    }
    componentMounted.current = true;
  }, [focus]);

  const handleInputFocus = (event) => onInputFocus(index, event);
  let inputType = 'text';
  if (otpType === 'number') {
    inputType = 'tel';
  }

  return (
    <Input
      backgroundColor="white"
      border={`1px solid ${COLORS.grey.lightest}`}
      borderRadius="10px"
      disabled={disabled}
      fontSize={isMobile ? '28px' : '44px'}
      fontWeight="medium"
      height={isMobile ? '65px' : '88px'}
      mr={isLast ? '0' : '16px'}
      maxLength="1"
      onFocus={handleInputFocus}
      ref={input}
      sx={{
        _hover: {
          backgroundColor: 'white',
        },
        _focus: {
          outline: 'none',
          border: `1px solid ${COLORS.blue.base}`,
          boxShadow: '0 0 4px rgba(67, 116, 232, 0.5)',
          backgroundColor: 'white',
        },
      }}
      textAlign="center"
      type={inputType}
      value={value}
      width={isMobile ? '65px' : '88px'}
      {...rest}
    />
  );
};

export default React.memo(OtpInput);
